import { useEffect, useState } from "react";
import { api } from "@/lib/api";

function isYouTubeUrl(u) {
  return /youtube\.com|youtu\.be/.test(u);
}
function toEmbed(url) {
  if (!url) return url;
  if (url.includes("/embed/")) return url;
  const ytMatch = url.match(/(?:v=|youtu\.be\/)([\w-]{6,})/);
  if (ytMatch) return `https://www.youtube.com/embed/${ytMatch[1]}`;
  return url;
}

export default function Videos() {
  const [videos, setVideos] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    api.get("/videos").then((r) => {
      setVideos(r.data);
      if (r.data.length) setActive(r.data[0]);
    });
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-6 py-16" data-testid="videos-page">
      <div className="section-eyebrow">Watch The King</div>
      <h1 className="font-display text-5xl lg:text-7xl uppercase mt-3">Videos</h1>
      <p className="text-dim mt-3 max-w-xl">Trailers, ring footage, and behind-the-scenes of the SCU.</p>

      {active && (
        <div className="mt-10 scu-card overflow-hidden" data-testid="active-video">
          <div className="aspect-video bg-black">
            {isYouTubeUrl(active.url) ? (
              <iframe
                title={active.title}
                src={toEmbed(active.url)}
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="w-full h-full"
              />
            ) : (
              <video src={active.url} controls poster={active.thumbnail} className="w-full h-full object-contain bg-black" />
            )}
          </div>
          <div className="p-6">
            <h2 className="font-display text-2xl uppercase">{active.title}</h2>
            <p className="text-dim mt-2">{active.description}</p>
          </div>
        </div>
      )}

      <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="videos-grid">
        {videos.map((v) => (
          <button key={v.id} onClick={() => setActive(v)} className="scu-card text-left group" data-testid={`video-card-${v.id}`}>
            <div className="aspect-video overflow-hidden bg-black">
              <img src={v.thumbnail} alt={v.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
            </div>
            <div className="p-4">
              <div className="font-display text-lg uppercase">{v.title}</div>
              <div className="text-dim text-xs mt-1 uppercase tracking-widest">{v.source}</div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
